<script>
  export let topArtists = [];
  export let hideVotes = false;

  function convertToPercentage(value, total = 17316) {
    return ((value / total) * 100).toFixed(2);
  }
</script>

{#each topArtists as artist}
  <li class="list-item">
    <a
      href={`https://stats.fm/artist/${artist.id}`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <img src={artist.image} alt={artist.name} class="list-image" />
      <span>
        <h3>{artist.name}</h3>
        {#if !hideVotes}
          <p>
            <!-- {artist.doc_count} vote{artist.doc_count > 1 ? 's' : ''} -->
            {convertToPercentage(artist.doc_count)}% of votes
          </p>
        {/if}
      </span>
    </a>
  </li>
{/each}

<style>
  .list-item a {
    display: flex;
    padding: 10px 14px;
    width: 100%;
    align-items: center;
    text-decoration: none; /* Removes underline from links */
    color: inherit; /* Inherits text color from parent */

    background-color: white;
    border-radius: 8px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  .list-item a:hover,
  .list-item a:focus {
    background-color: #e9ecef; /* Highlight color on hover/focus */
  }

  .list-item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
  }

  .list-image {
    border-radius: 50%;
    width: 50px;
    height: 50px;
    margin-right: 12px;
  }

  p,
  h3 {
    margin: 0;
    /* padding: 0; */
  }
  h3 {
    font-size: 1.2rem !important;
    margin-bottom: 3px;
  }
</style>
